export const NOVA_TILT_RANGES: Record<string, { min: number; max: number }> = {
  'No tilt': { min: 0, max: 0 },
  '10-15 deg': { min: 10, max: 15 },
  '15-30 deg': { min: 15, max: 30 },
  '30-60 deg': { min: 30, max: 60 },
  'A-frame (15-30 deg)': { min: 15, max: 30 },
}
